"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const createIdea_1 = require("../../../app/dist/createIdea");
exports.toolDef = {
    name: 'loom_create_idea',
    description: 'Create a new idea document in a specific thread — one idea per thread. Requires the thread\'s stable th_ ULID (create the thread first with loom_create_thread); an idea is never created loose at weave root and never mints a thread. **Always pass `content` to write the full body in this same call** — the doc is born at version 1 with real content. Only omit `content` if you genuinely do not have the body yet; do NOT create a stub and immediately follow with loom_update_doc — that is a wasted round-trip. The doc is created at status "draft" — finalize separately. Use this tool to create Loom idea docs — do not edit weave files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Target weave folder slug (directory name under loom/)' },
            thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread to place the idea in (create the thread first with loom_create_thread).' },
            title: { type: 'string', description: 'Human-readable title for the idea' },
            content: { type: 'string', description: 'Markdown body (no frontmatter). Provide this on creation so the doc is born at version 1 with real content — no follow-up loom_update_doc needed. Omit only if you truly have no body yet.' },
        },
        required: ['weave_slug', 'thread_ulid', 'title'],
    },
};
async function handle(root, args) {
    const input = {
        weaveSlug: args['weave_slug'],
        threadUlid: args['thread_ulid'],
        title: args['title'],
        content: args['content'],
    };
    const result = await (0, createIdea_1.createIdea)(input, {
        getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root),
        saveDoc: dist_1.saveDoc,
        loadDoc: dist_1.loadDoc,
        fs,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
